
  import {Injectable} from "@angular/core";
  @Injectable()
  export class HelperService {
     constructor() {}
     getBase64Image(img) {
        const canvas = document.createElement("canvas");
        img.crossOrigin="anonymous";
        canvas.width = img.width;
        canvas.height = img.height;
        const ctx = canvas.getContext("2d");
        ctx.drawImage(img, 0, 0);
        const dataURL = canvas.toDataURL("image/png");
        return dataURL.replace(/^data:image\/(png|jpg);base64,/, "");
      }

      getBase64URL(url: string) {
        // To bypass errors (“Tainted canvases may not be exported” or “SecurityError: The operation is insecure”)
        // The browser must load the image via non-authenticated request and following CORS headers
        const img = new Image();
        // img.crossOrigin = 'Anonymous';

        // The magic begins after the image is successfully loaded
        img.onload = function () {
          const canvas = document.createElement('canvas'),
            ctx = canvas.getContext('2d');

          canvas.height = img.naturalHeight;
          canvas.width = img.naturalWidth;
          ctx.drawImage(img, 0, 0);

          // Unfortunately, we cannot keep the original image type, so all images will be converted to PNG
          // For this reason, we cannot get the original Base64 string
          const uri = canvas.toDataURL('image/png'),
            b64 = uri.replace(/^data:image.+;base64,/, '');
        };
        img.src = url;
      }
      async  getBase64ImageFromUrl(imageUrl) {
        const res = await fetch(imageUrl);
        const blob = await res.blob();

        return new Promise((resolve, reject) => {
          const reader  = new FileReader();
          reader.addEventListener("load", function () {
              resolve(reader.result);
          }, false);

          reader.onerror = () => {
            return reject(this);
          };
          reader.readAsDataURL(blob);
        })
      }
}
